import { Component } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'qw-app-four-o-four',
    templateUrl: './app-four-o-four.component.html',
    styleUrls: ['./app-four-o-four.component.scss'],
    standalone: true,
    imports: [FaIconComponent],
})
export class AppFourOFourComponent {
}
